// Chargement après DOM ready
document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('product-crosssell-manager')) {
    customElements.define('product-crosssell-manager', ProductCrosssellManager);
  }
});

class ProductCrosssellManager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeTracking();
  }

  initializeTracking() {
    
    // Écouter les clics sur les boutons "Configurer"
    const configureButtons = this.querySelectorAll('.product-crosssell-item__configure-btn');
    
    configureButtons.forEach(button => {
      button.addEventListener('click', this.handleConfigureClick.bind(this));
    });
    
  }

  handleConfigureClick(event) {
    const button = event.currentTarget;
    const productItem = button.closest('.product-crosssell-item');
    const productId = productItem.dataset.productId;
    const productTitle = productItem.querySelector('.product-crosssell-item__title')?.textContent;
    const productPrice = productItem.querySelector('.product-crosssell-item__price-current')?.textContent;


    // Vérifier si le produit est disponible
    if (button.hasAttribute('data-unavailable')) {
      this.showUnavailableMessage(button);
      event.preventDefault();
      return;
    }

    // Ajouter un effet visuel au clic
    this.addClickEffect(button);

    // Événement personnalisé pour le tracking
    this.dispatchEvent(new CustomEvent('crosssell-clicked', {
      detail: {
        productId: productId,
        title: productTitle,
        price: productPrice,
        url: button.href
      },
      bubbles: true
    }));

    // Le lien se fera naturellement vers la page produit
    // Pas besoin de preventDefault() car on veut la redirection
  }

  addClickEffect(button) {
    // Effet visuel temporaire
    button.style.transform = 'scale(0.95)';
    
    setTimeout(() => {
      button.style.transform = '';
    }, 150);
  }

  showUnavailableMessage(button) {
    // Animation pour produit indisponible
    const originalText = button.textContent;
    button.textContent = 'Indisponible';
    button.style.animation = 'shake 0.5s ease-in-out';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.animation = '';
    }, 2000);
  }
}

// Ajouter les styles CSS pour les animations
const crosssellStyles = document.createElement('style');
crosssellStyles.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
    20%, 40%, 60%, 80% { transform: translateX(2px); }
  }
  
  /* Animation au survol pour les items cross-sell */
  .product-crosssell-item {
    transition: all 0.3s ease;
  }
  
  .product-crosssell-item:hover {
    transform: translateY(-2px);
  }
  
  /* Animation au clic sur le bouton configurer */
  .product-crosssell-item__configure-btn {
    transition: all 0.2s ease;
  }
  
  .product-crosssell-item__configure-btn:active {
    transform: scale(0.95);
  }
`;
document.head.appendChild(crosssellStyles);